import { render, staticRenderFns } from "./topVideo.vue?vue&type=template&id=a4ec3a34&"
import script from "./topVideo.vue?vue&type=script&lang=js&"
export * from "./topVideo.vue?vue&type=script&lang=js&"
import style0 from "./topVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "topVideo.vue"
export default component.exports